export const neighborhoods = {
  'tacoma-north-end': {
    slug: 'tacoma-north-end-homes',
    name: 'North End',
    city: 'Tacoma',
    citySlug: 'tacoma-real-estate-agent',
    county: 'Pierce County',
    lat: 47.2746,
    lng: -122.4857,
    title: 'North End Tacoma Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      "North End Tacoma real estate expert. Mazen El-Majzoub knows the craftsman homes, view lots, and Old Town charm. Call (253) 315-9480.",
    headline: 'North End Tacoma',
    intro:
      "The North End is Tacoma's crown jewel — tree-lined streets, preserved craftsman architecture, sweeping Puget Sound views, and a walkable tie to Ruston Way and Old Town. It's one of the most sought-after pockets in South Sound, and buyers need an agent who understands what makes each block different.",
    highlights: [
      'Craftsman, Tudor, and mid-century architecture predominates',
      'Walking distance to Ruston Way waterfront and Point Defiance Park',
      'Access to Stadium High School district (among Tacoma\'s best)',
      'Strong resale demand — limited inventory moves quickly',
    ],
    market:
      "North End homes typically trade at a premium to Tacoma's median — often $100,000+ over the city average, with view properties climbing significantly higher. Inventory is consistently tight; competitive offers with minimal contingencies often win.",
    heroImage: 'https://images.unsplash.com/photo-1518780664697-55e3ad937233?w=1600&q=80',
  },

  'proctor-tacoma': {
    slug: 'proctor-tacoma-homes',
    name: 'Proctor',
    city: 'Tacoma',
    citySlug: 'tacoma-real-estate-agent',
    county: 'Pierce County',
    lat: 47.2636,
    lng: -122.4856,
    title: 'Proctor District Tacoma Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Homes for sale in the Proctor District of Tacoma. Walkable village, craftsman homes, top schools. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Proctor District, Tacoma',
    intro:
      "Proctor is where Tacoma feels like a small town inside a city — a walkable commercial village surrounded by some of the best-kept residential blocks in South Sound. The district draws families, professionals, and downsizers who want character homes and Saturday morning farmers markets within strolling distance.",
    highlights: [
      'Walkable to Proctor farmers market, Metropolitan Market, and local shops',
      'Craftsman, Tudor, and Dutch colonial homes dominate the streets',
      'Bryant Elementary / Mason Middle / Stadium High feeder pattern',
      'Strong, steady resale demand — homes rarely sit',
    ],
    market:
      "Proctor homes price similarly to North End — premium to Tacoma median. Well-maintained craftsmans on double lots command the top of the range. Many buyers here stay for decades, keeping inventory perpetually tight.",
    heroImage: 'https://images.unsplash.com/photo-1448630360428-65456885c650?w=1600&q=80',
  },

  'ballard-seattle': {
    slug: 'ballard-seattle-homes',
    name: 'Ballard',
    city: 'Seattle',
    citySlug: 'seattle-real-estate-agent',
    county: 'King County',
    lat: 47.6691,
    lng: -122.3842,
    title: 'Ballard Seattle Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Homes for sale in Ballard, Seattle. Craftsman bungalows, modern townhomes, walkable Ballard Avenue. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Ballard, Seattle',
    intro:
      "Ballard balances Seattle's urban density with a distinctly neighborhood feel. Craftsman bungalows and modern townhomes share streets, Ballard Avenue anchors a food and nightlife scene that rivals anywhere in the city, and proximity to the Ship Canal and Golden Gardens gives it a water-adjacent character most Seattle neighborhoods lack.",
    highlights: [
      'Walkable to Ballard Avenue, breweries, and Sunday farmers market',
      'Mix of craftsman single-family homes and new townhouse construction',
      'Adams Elementary / Whitman Middle / Ballard High feeder pattern',
      'Strong bike/transit access to downtown and Fremont',
    ],
    market:
      "Ballard pricing varies dramatically by block — the historic center runs premium, newer townhouse developments offer more accessible entry points. Townhomes typically range $700k–$1M; single-family homes often $1M+. Competitive offer environment for well-priced listings.",
    heroImage: 'https://images.unsplash.com/photo-1441906363429-0d71d3f97a62?w=1600&q=80',
  },

  'queen-anne-seattle': {
    slug: 'queen-anne-seattle-homes',
    name: 'Queen Anne',
    city: 'Seattle',
    citySlug: 'seattle-real-estate-agent',
    county: 'King County',
    lat: 47.6372,
    lng: -122.3568,
    title: 'Queen Anne Seattle Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Homes and condos for sale on Queen Anne hill in Seattle. Iconic views, classic architecture. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Queen Anne, Seattle',
    intro:
      "Queen Anne sits on the hill that every Seattle skyline photo centers on — and the view from the top is why this neighborhood has been among Seattle's premier addresses for over a century. Upper Queen Anne offers a walkable village feel; Lower Queen Anne connects directly to Seattle Center, the monorail, and downtown.",
    highlights: [
      'Iconic view homes — Elliott Bay, downtown, Mount Rainier',
      'Mix of historic mansions, classic single-family, and condos',
      'Walking access to Kerry Park, Seattle Center, and downtown',
      'John Hay Elementary / McClure Middle feeder pattern',
    ],
    market:
      "Queen Anne commands top-of-Seattle pricing — view homes regularly sell above $2M, and condos in desirable buildings hold premium per-square-foot pricing. Inventory is tight; turnover slow. This is a precision market where pricing, staging, and comp analysis matter.",
    heroImage: 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=1600&q=80',
  },

  'oakbrook-lakewood': {
    slug: 'oakbrook-lakewood-homes',
    name: 'Oakbrook',
    city: 'Lakewood',
    citySlug: 'lakewood-real-estate-agent',
    county: 'Pierce County',
    lat: 47.1523,
    lng: -122.5437,
    title: 'Oakbrook Lakewood Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Homes for sale in the Oakbrook neighborhood of Lakewood, WA. Mature lots, strong schools, quiet streets. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Oakbrook, Lakewood',
    intro:
      "Oakbrook is one of Lakewood's most established residential neighborhoods — mature landscaping, bigger lots than you'd expect this close to Tacoma, and a quiet, family-oriented feel. Popular with JBLM-connected buyers looking for more space than Tacoma offers at similar price points.",
    highlights: [
      'Larger lots than typical Pierce County suburbs',
      'Oakbrook Golf & Country Club adjacent',
      'Clover Park School District zoning',
      'Short drive to JBLM main gate',
    ],
    market:
      "Oakbrook runs above the Lakewood median — established neighborhood, larger lots, and steady demand from military relocations keep prices firm. Most transactions close with VA financing; experienced representation on the VA process matters.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  'old-town-tacoma': {
    slug: 'old-town-tacoma-homes',
    name: 'Old Town',
    city: 'Tacoma',
    citySlug: 'tacoma-real-estate-agent',
    county: 'Pierce County',
    lat: 47.2755,
    lng: -122.4619,
    title: 'Old Town Tacoma Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Old Town Tacoma homes for sale. Waterfront district, historic character, Ruston Way access. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Old Town Tacoma',
    intro:
      "Old Town is Tacoma's original waterfront neighborhood — walkable streets, historic homes, and direct access to Ruston Way and Commencement Bay views. It attracts buyers who want Tacoma history with modern amenities nearby.",
    highlights: [
      'Walking distance to Ruston Way waterfront',
      'Historic Victorian and craftsman stock',
      'Close to Old Town Dock and Chinese Reconciliation Park',
      'Access to Stadium High School district',
    ],
    market:
      "Old Town inventory is small and varied — everything from restored Victorians to modern infill townhomes. Pricing reflects proximity to the water; view homes command real premiums.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  'stadium-district-tacoma': {
    slug: 'stadium-district-tacoma-homes',
    name: 'Stadium District',
    city: 'Tacoma',
    citySlug: 'tacoma-real-estate-agent',
    county: 'Pierce County',
    lat: 47.2624,
    lng: -122.4483,
    title: 'Stadium District Tacoma Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Stadium District Tacoma homes. Historic neighborhood next to Stadium High, walkable to downtown. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Stadium District, Tacoma',
    intro:
      "Stadium District centers on Tacoma's signature Stadium High School — a historic neighborhood with character homes, tree-lined streets, and walkable access to downtown. It's one of Tacoma's most recognizable addresses.",
    highlights: [
      'Stadium High School attendance area',
      'Walkable to downtown Tacoma',
      'Historic homes from Tacoma\'s early 1900s boom',
      'Mix of single-family, townhomes, and historic apartments',
    ],
    market:
      "Stadium District pricing runs premium for well-preserved period homes. Turnover is slow — owners tend to stay. When inventory appears, offers come quickly.",
    heroImage: 'https://images.unsplash.com/photo-1441906363429-0d71d3f97a62?w=1600&q=80',
  },

  'hilltop-tacoma': {
    slug: 'hilltop-tacoma-homes',
    name: 'Hilltop',
    city: 'Tacoma',
    citySlug: 'tacoma-real-estate-agent',
    county: 'Pierce County',
    lat: 47.2475,
    lng: -122.4520,
    title: 'Hilltop Tacoma Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Hilltop Tacoma homes for sale. Revitalized historic neighborhood, light rail access, value opportunity. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Hilltop, Tacoma',
    intro:
      "Hilltop is Tacoma's most actively revitalizing neighborhood. Historic craftsman and Victorian homes, light rail connecting to downtown, and pricing that still trails North End — a value window that's closing quickly.",
    highlights: [
      'Tacoma Link light rail access',
      'Historic architectural stock',
      'Price per square foot value vs North End',
      'Walking distance to Wright Park and Tacoma General',
    ],
    market:
      "Hilltop pricing has climbed substantially but remains below Tacoma's premium neighborhoods. Early-mover buyers benefit as revitalization continues. I help clients read block-by-block value variation.",
    heroImage: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=80',
  },

  'sixth-ave-tacoma': {
    slug: 'sixth-ave-tacoma-homes',
    name: '6th Ave',
    city: 'Tacoma',
    citySlug: 'tacoma-real-estate-agent',
    county: 'Pierce County',
    lat: 47.2597,
    lng: -122.4769,
    title: '6th Avenue Tacoma Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      '6th Avenue Tacoma homes for sale. Walkable commercial corridor, craftsman streets, creative community. Mazen El-Majzoub. (253) 315-9480.',
    headline: '6th Avenue District, Tacoma',
    intro:
      "6th Ave (pronounced 'Six Ave' locally) is Tacoma's creative commercial corridor — restaurants, shops, music venues — surrounded by walkable residential blocks. It draws younger buyers, creatives, and anyone prioritizing neighborhood over square footage.",
    highlights: [
      'Walkable to 6th Ave bars, restaurants, and music venues',
      'Bungalow and craftsman housing stock',
      'Strong appeal to professionals and creatives',
      'Easy commute to downtown Tacoma and I-5',
    ],
    market:
      "6th Ave homes trade on character and location. Updated craftsmans command premiums; unrenovated homes offer entry-level pricing for buyers willing to invest. Competitive multi-offer situations on well-staged listings.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  'capitol-hill-seattle': {
    slug: 'capitol-hill-seattle-homes',
    name: 'Capitol Hill',
    city: 'Seattle',
    citySlug: 'seattle-real-estate-agent',
    county: 'King County',
    lat: 47.6237,
    lng: -122.3220,
    title: 'Capitol Hill Seattle Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Capitol Hill Seattle homes and condos for sale. Historic craftsmans, urban condos, walkable density. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Capitol Hill, Seattle',
    intro:
      "Capitol Hill is Seattle's densest, most walkable neighborhood — a mix of grand historic homes in Millionaire's Row, craftsman streets north of Broadway, and modern condos throughout. Cultural epicenter of the city.",
    highlights: [
      'Volunteer Park and Cal Anderson Park access',
      'Walk to restaurants, bars, music venues, shops',
      'Historic mansions along 14th Avenue',
      'Light rail access to downtown and UW',
    ],
    market:
      "Capitol Hill blends single-family, condo, and townhouse inventory — each with its own pricing logic. Single-family can top $2M; entry-level condos start near $400k. I help clients match housing type to lifestyle.",
    heroImage: 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=1600&q=80',
  },

  'fremont-seattle': {
    slug: 'fremont-seattle-homes',
    name: 'Fremont',
    city: 'Seattle',
    citySlug: 'seattle-real-estate-agent',
    county: 'King County',
    lat: 47.6513,
    lng: -122.3501,
    title: 'Fremont Seattle Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Fremont Seattle homes for sale. Ship Canal waterfront, craftsman streets, tech employer demand. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Fremont, Seattle',
    intro:
      "Fremont — 'the center of the universe' — combines quirky neighborhood identity with Ship Canal waterfront and heavy tech-employer demand (Google, Adobe, Tableau campuses all anchor here).",
    highlights: [
      'Ship Canal waterfront and Fremont Bridge access',
      'Walking distance to Fremont Brewing, Sunday Market',
      'Mix of craftsman single-family and modern townhomes',
      'Heavy tech-employer buyer pool',
    ],
    market:
      "Fremont pricing tracks tech-employer demand. New townhome construction keeps supply flowing but single-family inventory is tight. Competitive offer environment on well-priced homes.",
    heroImage: 'https://images.unsplash.com/photo-1441906363429-0d71d3f97a62?w=1600&q=80',
  },

  'magnolia-seattle': {
    slug: 'magnolia-seattle-homes',
    name: 'Magnolia',
    city: 'Seattle',
    citySlug: 'seattle-real-estate-agent',
    county: 'King County',
    lat: 47.6500,
    lng: -122.4017,
    title: 'Magnolia Seattle Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Magnolia Seattle homes for sale. View neighborhood, Discovery Park, classic single-family blocks. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Magnolia, Seattle',
    intro:
      "Magnolia is Seattle's quiet view neighborhood — Discovery Park at one end, Puget Sound views along the bluffs, and classic residential streets filled with mid-century and craftsman homes. A family-oriented enclave.",
    highlights: [
      'Discovery Park — 500+ acres of city parkland',
      'View homes along the bluff',
      'Single-family dominant — limited condo stock',
      'Catharine Blaine K-8 and McClure Middle feeder pattern',
    ],
    market:
      "Magnolia inventory turns over slowly. View homes command substantial premiums; non-view homes trade on school district and neighborhood feel. Precise CMA matters here.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  'wallingford-seattle': {
    slug: 'wallingford-seattle-homes',
    name: 'Wallingford',
    city: 'Seattle',
    citySlug: 'seattle-real-estate-agent',
    county: 'King County',
    lat: 47.6588,
    lng: -122.3348,
    title: 'Wallingford Seattle Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Wallingford Seattle homes for sale. Craftsman bungalows, walkable 45th Ave, UW adjacent. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Wallingford, Seattle',
    intro:
      "Wallingford sits between Fremont and the U District — classic Seattle craftsman bungalows, walkable 45th Avenue corridor, and strong family demand. Pricing splits between modernized homes and project properties.",
    highlights: [
      'Craftsman bungalows dominant',
      'Walk to 45th Ave restaurants and Gas Works Park',
      'UW-adjacent — strong rental demand',
      'McDonald International Elementary / Hamilton Middle / Lincoln High',
    ],
    market:
      "Wallingford rewards buyers who know the difference between an updated 1920s craftsman and one that still has knob-and-tube wiring. Condition matters enormously; inspections are critical here.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  'bridle-trails-bellevue': {
    slug: 'bridle-trails-bellevue-homes',
    name: 'Bridle Trails',
    city: 'Bellevue',
    citySlug: 'bellevue-real-estate-agent',
    county: 'King County',
    lat: 47.6345,
    lng: -122.1692,
    title: 'Bridle Trails Bellevue Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Bridle Trails Bellevue homes for sale. Equestrian neighborhood, wooded lots, top schools. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Bridle Trails, Bellevue',
    intro:
      "Bridle Trails is Bellevue's equestrian-character neighborhood — wooded lots, horse trails through Bridle Trails State Park, and an unusually private feel for a Bellevue address. Top schools and executive-tier pricing.",
    highlights: [
      'Bridle Trails State Park with equestrian trails',
      'Large wooded lots uncommon in Bellevue',
      'Lake Washington School District',
      'Executive and luxury-tier pricing',
    ],
    market:
      "Bridle Trails inventory is thin — homes here stay in families for decades. When they list, pricing is precise and offers are strong. Horse-property due diligence matters.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  medina: {
    slug: 'medina-bellevue-homes',
    name: 'Medina',
    city: 'Bellevue',
    citySlug: 'bellevue-real-estate-agent',
    county: 'King County',
    lat: 47.6200,
    lng: -122.2304,
    title: 'Medina Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Medina WA homes for sale. Lake Washington waterfront, Bellevue School District, executive addresses. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Medina, Washington',
    intro:
      "Medina is one of the most exclusive residential addresses in Washington — Lake Washington waterfront, Bill Gates and Jeff Bezos properties included, and tight-knit small-town feel between Bellevue and the lake. Inventory is scarce; most transactions are relationship-driven.",
    highlights: [
      'Lake Washington waterfront — premier addresses in state',
      'Bellevue School District',
      'Private, low-density residential streets',
      'Off-market and pocket-listing network',
    ],
    market:
      "Medina rarely sees homes listed publicly. Pricing runs $5M-$30M+ on waterfront. Access matters as much as capital — this market trades through networks, not portals.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },

  'clyde-hill-bellevue': {
    slug: 'clyde-hill-bellevue-homes',
    name: 'Clyde Hill',
    city: 'Bellevue',
    citySlug: 'bellevue-real-estate-agent',
    county: 'King County',
    lat: 47.6354,
    lng: -122.2173,
    title: 'Clyde Hill Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Clyde Hill WA homes for sale. Premier Bellevue view addresses, Bellevue School District. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Clyde Hill, Washington',
    intro:
      "Clyde Hill sits on the high ground between Bellevue and Medina — view lots, executive-tier single-family, and one of the most desirable school-district addresses on the Eastside. Pricing reflects that.",
    highlights: [
      'Lake Washington and Seattle skyline views',
      'Bellevue School District — top schools statewide',
      'Large residential lots',
      'Executive-tier pricing with strong resale',
    ],
    market:
      "Clyde Hill inventory is thin. View homes command substantial premiums. Buyers need strong financing; sellers need precision pricing and marketing to the international executive buyer pool.",
    heroImage: 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=1600&q=80',
  },

  'west-end-tacoma': {
    slug: 'west-end-tacoma-homes',
    name: 'West End',
    city: 'Tacoma',
    citySlug: 'tacoma-real-estate-agent',
    county: 'Pierce County',
    lat: 47.2459,
    lng: -122.4961,
    title: 'West End Tacoma Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'West End Tacoma homes for sale. Titlow, Narrows, waterfront adjacency. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'West End, Tacoma',
    intro:
      "The West End fronts the Narrows — Titlow Beach, view homes on the bluff, and access to the Narrows Bridge. A quieter alternative to North End with water-adjacent character.",
    highlights: ['Titlow Beach Park access', 'Narrows views', 'Access to University Place and Narrows Bridge', 'Mix of mid-century and newer construction'],
    market: "West End pricing reflects water proximity. View homes along the bluff trade at premium; inland homes offer more accessible entry points.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  'south-tacoma': {
    slug: 'south-tacoma-homes',
    name: 'South Tacoma',
    city: 'Tacoma',
    citySlug: 'tacoma-real-estate-agent',
    county: 'Pierce County',
    lat: 47.2088,
    lng: -122.4618,
    title: 'South Tacoma Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'South Tacoma homes for sale. Value pricing, historic blocks, revitalization momentum. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'South Tacoma',
    intro:
      "South Tacoma is one of the city's most active value markets — historic blocks, revitalizing commercial corridor, and pricing that still trails central Tacoma.",
    highlights: ['Tacoma Public Schools', 'Revitalizing South Tacoma Way corridor', 'Entry-level single-family pricing', 'Tacoma Dome proximity'],
    market: "South Tacoma pricing has climbed from historic lows but remains below central and North End Tacoma. Investor competition is real; owner-occupants need local knowledge to compete.",
    heroImage: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=80',
  },

  'eastside-tacoma': {
    slug: 'eastside-tacoma-homes',
    name: 'Eastside',
    city: 'Tacoma',
    citySlug: 'tacoma-real-estate-agent',
    county: 'Pierce County',
    lat: 47.2314,
    lng: -122.4145,
    title: 'Eastside Tacoma Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Eastside Tacoma homes for sale. Portland Ave corridor, investment property, value. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Eastside, Tacoma',
    intro:
      "The Eastside is Tacoma's port-adjacent residential area — historic blocks along Portland Ave, strong investor activity, and some of the most affordable pricing in the city.",
    highlights: ['Tacoma Public Schools', 'Portland Ave revitalization', 'Investment property market', 'Lowest per-square-foot pricing in Tacoma'],
    market: "Eastside is heavily investor-driven. Owner-occupants need strong financing positions to compete against cash offers.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  'green-lake-seattle': {
    slug: 'green-lake-seattle-homes',
    name: 'Green Lake',
    city: 'Seattle',
    citySlug: 'seattle-real-estate-agent',
    county: 'King County',
    lat: 47.6792,
    lng: -122.3273,
    title: 'Green Lake Seattle Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Green Lake Seattle homes for sale. Lakeside living, craftsman homes, walkable community. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Green Lake, Seattle',
    intro:
      "Green Lake centers on the 2.8-mile loop around the lake itself — one of Seattle's most iconic walkable neighborhoods. Craftsman homes, lake views, and strong family demand.",
    highlights: ['Green Lake loop and park', 'Craftsman architectural stock', 'Family-oriented walkable community', 'Proximity to Woodland Park Zoo'],
    market: "Green Lake inventory turns slowly. Lake-view homes command significant premiums; craftsman bungalows trade on condition and block.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  'madison-park-seattle': {
    slug: 'madison-park-seattle-homes',
    name: 'Madison Park',
    city: 'Seattle',
    citySlug: 'seattle-real-estate-agent',
    county: 'King County',
    lat: 47.6359,
    lng: -122.2782,
    title: 'Madison Park Seattle Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Madison Park Seattle homes for sale. Lake Washington waterfront, top schools, village feel. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Madison Park, Seattle',
    intro:
      "Madison Park is Seattle's lakefront village — a tight walkable commercial core, Lake Washington beach access, and some of the most desirable residential blocks in the city.",
    highlights: ['Lake Washington beach access', 'Walkable village core', 'McGilvra Elementary — top Seattle Public Schools', 'Executive-tier pricing'],
    market: "Madison Park inventory is thin and expensive. Waterfront homes regularly top $5M; non-waterfront homes trade on block location and school access.",
    heroImage: 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=1600&q=80',
  },

  'beacon-hill-seattle': {
    slug: 'beacon-hill-seattle-homes',
    name: 'Beacon Hill',
    city: 'Seattle',
    citySlug: 'seattle-real-estate-agent',
    county: 'King County',
    lat: 47.5787,
    lng: -122.3090,
    title: 'Beacon Hill Seattle Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Beacon Hill Seattle homes for sale. Craftsman homes, light rail, diverse community. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Beacon Hill, Seattle',
    intro:
      "Beacon Hill offers Seattle light rail access at pricing below Capitol Hill or Ballard — diverse community, craftsman and mid-century homes, and city views from the ridge.",
    highlights: ['Sound Transit light rail station', 'Craftsman and mid-century stock', 'Diverse community feel', 'Downtown and Mount Rainier views'],
    market: "Beacon Hill pricing has climbed with light rail but still offers value vs Capitol Hill or Queen Anne. View lots command premiums.",
    heroImage: 'https://images.unsplash.com/photo-1441906363429-0d71d3f97a62?w=1600&q=80',
  },

  'columbia-city-seattle': {
    slug: 'columbia-city-seattle-homes',
    name: 'Columbia City',
    city: 'Seattle',
    citySlug: 'seattle-real-estate-agent',
    county: 'King County',
    lat: 47.5595,
    lng: -122.2843,
    title: 'Columbia City Seattle Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Columbia City Seattle homes for sale. Walkable village, light rail, historic character. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Columbia City, Seattle',
    intro:
      "Columbia City combines a walkable commercial main street with craftsman residential blocks and Sound Transit light rail access. One of the fastest-changing Seattle neighborhoods.",
    highlights: ['Light rail access to downtown and SeaTac', 'Historic main street district', 'Craftsman housing stock', 'Walkable farmers market'],
    market: "Columbia City pricing has risen substantially as light rail and main street revitalization continue. Still below Capitol Hill and Ballard on per-square-foot basis.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  'madrona-seattle': {
    slug: 'madrona-seattle-homes',
    name: 'Madrona',
    city: 'Seattle',
    citySlug: 'seattle-real-estate-agent',
    county: 'King County',
    lat: 47.6107,
    lng: -122.2819,
    title: 'Madrona Seattle Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Madrona Seattle homes for sale. Lake Washington views, historic homes, tight village. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Madrona, Seattle',
    intro:
      "Madrona perches above Lake Washington — view homes, historic character, and a quiet walkable village at 34th Ave. One of Seattle's most storied addresses.",
    highlights: ['Madrona Park and Lake Washington access', 'Historic craftsman and Tudor stock', 'Walkable 34th Ave village', 'View homes along Lake Washington Blvd'],
    market: "Madrona turns over slowly. View homes command substantial premiums; inland blocks still trade at premium to most of Seattle.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  'lake-hills-bellevue': {
    slug: 'lake-hills-bellevue-homes',
    name: 'Lake Hills',
    city: 'Bellevue',
    citySlug: 'bellevue-real-estate-agent',
    county: 'King County',
    lat: 47.5842,
    lng: -122.1450,
    title: 'Lake Hills Bellevue Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Lake Hills Bellevue homes for sale. Family neighborhood, Bellevue schools, value. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Lake Hills, Bellevue',
    intro:
      "Lake Hills is a family-oriented Bellevue neighborhood — mid-century single-family stock, Bellevue School District, and more accessible pricing than Somerset or Bridle Trails.",
    highlights: ['Bellevue School District', 'Mid-century housing stock', 'Lake Hills Greenbelt', 'Value vs premium Bellevue neighborhoods'],
    market: "Lake Hills is Bellevue's relative value — still commanding strong prices but below the executive tiers. Family-driven demand keeps inventory moving.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },

  'factoria-bellevue': {
    slug: 'factoria-bellevue-homes',
    name: 'Factoria',
    city: 'Bellevue',
    citySlug: 'bellevue-real-estate-agent',
    county: 'King County',
    lat: 47.5796,
    lng: -122.1624,
    title: 'Factoria Bellevue Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Factoria Bellevue homes for sale. Condos, townhomes, Bellevue College. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Factoria, Bellevue',
    intro:
      "Factoria is Bellevue's south commercial and residential hub — condos, townhomes, and newer construction. Entry point into Bellevue for many first-time buyers.",
    highlights: ['Bellevue College proximity', 'Factoria Mall and retail hub', 'Strong condo and townhome market', 'Bellevue School District access'],
    market: "Factoria condos and townhomes trade at the accessible end of Bellevue pricing. First-time buyers compete with investors here.",
    heroImage: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=80',
  },

  'tillicum-lakewood': {
    slug: 'tillicum-lakewood-homes',
    name: 'Tillicum',
    city: 'Lakewood',
    citySlug: 'lakewood-real-estate-agent',
    county: 'Pierce County',
    lat: 47.1358,
    lng: -122.5440,
    title: 'Tillicum Lakewood Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Tillicum Lakewood homes for sale. American Lake access, JBLM-adjacent, value. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Tillicum, Lakewood',
    intro:
      "Tillicum sits directly adjacent to JBLM — American Lake access, affordable pricing, and strong military buyer demand.",
    highlights: ['Clover Park School District', 'JBLM immediate proximity', 'American Lake access', 'VA loan transaction experience'],
    market: "Tillicum is entry-level Lakewood. Military cycles drive turnover; savvy investors compete with owner-occupants.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  'american-lake-lakewood': {
    slug: 'american-lake-lakewood-homes',
    name: 'American Lake',
    city: 'Lakewood',
    citySlug: 'lakewood-real-estate-agent',
    county: 'Pierce County',
    lat: 47.1553,
    lng: -122.5557,
    title: 'American Lake Lakewood Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'American Lake waterfront homes for sale in Lakewood. Lakefront, JBLM access. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'American Lake, Lakewood',
    intro:
      "American Lake is Lakewood's signature waterfront — private lakefront homes, view lots, and a premium pocket within the city.",
    highlights: ['American Lake waterfront inventory', 'Clover Park School District', 'JBLM proximity', 'Boating and recreation access'],
    market: "American Lake waterfront trades at substantial premium. Tight inventory; buyers need to move quickly when homes appear.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  'south-hill-puyallup': {
    slug: 'south-hill-puyallup-homes',
    name: 'South Hill',
    city: 'Puyallup',
    citySlug: 'puyallup-real-estate-agent',
    county: 'Pierce County',
    lat: 47.1467,
    lng: -122.2859,
    title: 'South Hill Puyallup Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'South Hill Puyallup homes for sale. Newer construction, family neighborhoods, Puyallup schools. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'South Hill, Puyallup',
    intro:
      "South Hill is Puyallup's suburban expansion — newer subdivisions, family-sized lots, and commercial amenities. Where most Puyallup new construction has happened.",
    highlights: ['Puyallup School District', 'Newer construction inventory', 'Family-sized lots', 'South Hill Mall and retail'],
    market: "South Hill pricing tracks Puyallup median. New-build vs resale tradeoffs matter — I help clients read both sides.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },

  'lipoma-firs-puyallup': {
    slug: 'lipoma-firs-puyallup-homes',
    name: 'Lipoma Firs',
    city: 'Puyallup',
    citySlug: 'puyallup-real-estate-agent',
    county: 'Pierce County',
    lat: 47.1258,
    lng: -122.2681,
    title: 'Lipoma Firs Puyallup Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Lipoma Firs Puyallup homes for sale. Newer construction community, family-focused. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Lipoma Firs, Puyallup',
    intro:
      "Lipoma Firs is one of South Hill's newer master-planned residential areas — consistent architecture, family-oriented streets, and strong resale demand.",
    highlights: ['Puyallup School District', 'Master-planned community feel', 'Newer construction', 'Commuter access to JBLM, Tacoma, Seattle'],
    market: "Lipoma Firs homes trade on predictable comps. New-construction incentives vs resale pricing matter here.",
    heroImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80',
  },

  'canterwood-gig-harbor': {
    slug: 'canterwood-homes',
    name: 'Canterwood',
    city: 'Gig Harbor',
    citySlug: 'gig-harbor-real-estate-agent',
    county: 'Pierce County',
    lat: 47.3617,
    lng: -122.6239,
    title: 'Canterwood Homes for Sale | Gig Harbor | Mazen El-Majzoub',
    metaDescription: 'Canterwood Gig Harbor homes for sale. Gated golf community, executive homes. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Canterwood, Gig Harbor',
    intro: "Canterwood is Gig Harbor's premier gated community — championship golf course, executive-tier homes, and one of the most sought-after addresses on the Peninsula.",
    highlights: ['Canterwood Golf and Country Club', 'Gated private community', 'Peninsula School District', 'Executive and luxury-tier inventory'],
    market: "Canterwood homes trade at top-of-market for Gig Harbor. Golf-course frontage commands substantial premiums. Inventory is thin; buyers need readiness.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },

  'point-ruston': {
    slug: 'point-ruston-homes',
    name: 'Point Ruston',
    city: 'Ruston',
    citySlug: 'ruston-real-estate-agent',
    county: 'Pierce County',
    lat: 47.3059,
    lng: -122.5111,
    title: 'Point Ruston Homes and Condos for Sale | Mazen El-Majzoub',
    metaDescription: 'Point Ruston waterfront condos and homes for sale. Commencement Bay views, walkable district. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Point Ruston',
    intro: "Point Ruston is one of Tacoma's premier waterfront mixed-use districts — Commencement Bay views, waterfront condos, restaurants, movie theater, and walkable trail access. Brand-name neighborhood with specific search demand.",
    highlights: ['Commencement Bay waterfront', 'Walkable retail and restaurant district', 'Ruston Way trail connection', 'Condo and townhome inventory'],
    market: "Point Ruston trades almost entirely in condos and townhomes. Building, floor, and view direction matter enormously. HOA review is critical.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  'sammamish-plateau': {
    slug: 'sammamish-plateau-homes',
    name: 'Sammamish Plateau',
    city: 'Sammamish',
    citySlug: 'sammamish-real-estate-agent',
    county: 'King County',
    lat: 47.6163,
    lng: -122.0356,
    title: 'Sammamish Plateau Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Sammamish Plateau homes for sale. Top schools, executive pricing, tech-employer demand. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Sammamish Plateau',
    intro: "The Sammamish Plateau anchors the city's highest-demand addresses — top-tier schools, executive-tier single-family stock, and heavy Microsoft-driven demand. Commonly searched by relocation buyers.",
    highlights: ['Lake Washington and Issaquah School Districts', 'Executive-tier single-family stock', 'Microsoft and Eastside tech access', 'Strong resale demand'],
    market: "Plateau homes trade on school district precision. Comps vary by attendance area more than by square footage. Pricing discipline is essential.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },

  'cottage-lake-woodinville': {
    slug: 'cottage-lake-homes',
    name: 'Cottage Lake',
    city: 'Woodinville',
    citySlug: 'woodinville-real-estate-agent',
    county: 'King County',
    lat: 47.7478,
    lng: -122.0781,
    title: 'Cottage Lake Woodinville Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Cottage Lake Woodinville homes for sale. Lakefront, semi-rural, Northshore schools. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Cottage Lake, Woodinville',
    intro: "Cottage Lake is Woodinville's semi-rural lakefront pocket — larger lots, lakefront homes, and equestrian-capable properties. Buyers search specifically for this area.",
    highlights: ['Cottage Lake waterfront inventory', 'Northshore School District', 'Semi-rural larger lots', 'Equestrian and horse properties'],
    market: "Cottage Lake waterfront and view homes command premium. Inland acreage appeals to buyers wanting Eastside access with rural space.",
    heroImage: 'https://images.unsplash.com/photo-1685841295958-2695cbed9093?w=1600&q=80',
  },

  'three-tree-point-burien': {
    slug: 'three-tree-point-homes',
    name: 'Three Tree Point',
    city: 'Burien',
    citySlug: 'burien-real-estate-agent',
    county: 'King County',
    lat: 47.4515,
    lng: -122.3791,
    title: 'Three Tree Point Burien Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Three Tree Point Burien waterfront homes for sale. Puget Sound views, exclusive pocket. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Three Tree Point, Burien',
    intro: "Three Tree Point is Burien's most exclusive waterfront pocket — private beach community, Puget Sound views, and some of the tightest inventory in South King County.",
    highlights: ['Private Puget Sound beach access', 'Highline School District', 'View homes along the bluff', 'Exclusive small-community feel'],
    market: "Three Tree Point inventory rarely lists. Waterfront and view premiums are substantial. Buyers need to be ready when listings appear.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  'mccormick-woods-port-orchard': {
    slug: 'mccormick-woods-homes',
    name: 'McCormick Woods',
    city: 'Port Orchard',
    citySlug: 'port-orchard-real-estate-agent',
    county: 'Kitsap County',
    lat: 47.5026,
    lng: -122.6956,
    title: 'McCormick Woods Port Orchard Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'McCormick Woods Port Orchard homes for sale. Golf community, master-planned, South Kitsap. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'McCormick Woods, Port Orchard',
    intro: "McCormick Woods is Kitsap's premier master-planned golf community — championship course, walking trails, and executive-tier single-family stock. Specific search demand from Kitsap and Navy buyers.",
    highlights: ['McCormick Woods Golf Course', 'South Kitsap School District', 'Master-planned community amenities', 'Naval Base Kitsap and VA loan market'],
    market: "McCormick Woods comps are predictable across the community. Golf-course-frontage lots command premium; new-construction continues in phases.",
    heroImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80',
  },

  'lake-wilderness-maple-valley': {
    slug: 'lake-wilderness-homes',
    name: 'Lake Wilderness',
    city: 'Maple Valley',
    citySlug: 'maple-valley-real-estate-agent',
    county: 'King County',
    lat: 47.3795,
    lng: -122.0413,
    title: 'Lake Wilderness Maple Valley Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Lake Wilderness Maple Valley waterfront homes for sale. Lakefront, Tahoma schools. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Lake Wilderness, Maple Valley',
    intro: "Lake Wilderness is Maple Valley's signature waterfront — 67-acre lake with lakefront homes, Lake Wilderness Park access, and one of the most searched Maple Valley pockets.",
    highlights: ['Lake Wilderness waterfront', 'Lake Wilderness Arboretum', 'Tahoma School District', 'Boating and recreation access'],
    market: "Lake Wilderness waterfront commands substantial premium to Maple Valley median. Tight inventory; buyers often wait months for the right home.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  'chambers-bay-university-place': {
    slug: 'chambers-bay-homes',
    name: 'Chambers Bay',
    city: 'University Place',
    citySlug: 'university-place-real-estate-agent',
    county: 'Pierce County',
    lat: 47.2036,
    lng: -122.5767,
    title: 'Chambers Bay Homes for Sale | University Place | Mazen El-Majzoub',
    metaDescription: 'Chambers Bay University Place homes for sale. Golf course community, Puget Sound views, premier UP address. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Chambers Bay, University Place',
    intro: "Chambers Bay is University Place's signature address — host of the 2015 U.S. Open, 930 acres of links-style golf, and some of the most sought-after view homes in Pierce County. Buyers specifically search for this neighborhood.",
    highlights: ['Chambers Bay Golf Course (2015 U.S. Open)', 'Puget Sound and Olympic Mountain views', 'University Place School District', 'Chambers Creek Regional Park trail system'],
    market: "Chambers Bay homes command premium pricing — view lots, golf course frontage, and the brand-name neighborhood all drive demand. Inventory is tight and offers move quickly when listings hit. I help buyers compete and sellers position correctly for this specific market.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  'dash-point-federal-way': {
    slug: 'dash-point-homes',
    name: 'Dash Point',
    city: 'Federal Way',
    citySlug: 'federal-way-real-estate-agent',
    county: 'King County',
    lat: 47.3190,
    lng: -122.4025,
    title: 'Dash Point Homes for Sale | Federal Way | Mazen El-Majzoub',
    metaDescription: 'Dash Point Federal Way homes for sale. Puget Sound waterfront, Dash Point State Park. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Dash Point, Federal Way',
    intro: "Dash Point is Federal Way's signature waterfront pocket — Puget Sound beach access, Dash Point State Park, and view homes on the bluff. One of the most searched submarkets in Federal Way.",
    highlights: ['Dash Point State Park waterfront', 'Federal Way School District', 'View homes along the bluff', 'Beach access and boat launch'],
    market: "Dash Point waterfront and view homes command substantial premiums over Federal Way median. Inland homes still benefit from the address premium.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  'redondo-federal-way': {
    slug: 'redondo-homes',
    name: 'Redondo',
    city: 'Federal Way',
    citySlug: 'federal-way-real-estate-agent',
    county: 'King County',
    lat: 47.3436,
    lng: -122.3247,
    title: 'Redondo Homes for Sale | Federal Way | Mazen El-Majzoub',
    metaDescription: 'Redondo Federal Way homes for sale. Redondo Beach waterfront, Puget Sound views. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Redondo, Federal Way',
    intro: "Redondo sits on Poverty Bay — Redondo Beach pier, waterfront community, and a quiet walkable alternative to Des Moines or Dash Point. Highly searched Federal Way pocket.",
    highlights: ['Redondo Beach pier and boardwalk', 'Federal Way and Highline School District coverage', 'Waterfront and view inventory', 'Walking distance to Poverty Bay restaurants'],
    market: "Redondo waterfront commands substantial premium. View homes along the slope trade above Federal Way median; inland Redondo addresses still benefit from the brand.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  'twin-lakes-federal-way': {
    slug: 'twin-lakes-federal-way-homes',
    name: 'Twin Lakes',
    city: 'Federal Way',
    citySlug: 'federal-way-real-estate-agent',
    county: 'King County',
    lat: 47.3110,
    lng: -122.3495,
    title: 'Twin Lakes Federal Way Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Twin Lakes Federal Way homes for sale. Established family neighborhood, golf course access. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Twin Lakes, Federal Way',
    intro:
      "Twin Lakes is one of Federal Way's most established neighborhoods — mature landscaping, golf course access, and strong long-term resident retention.",
    highlights: ['Federal Way School District', 'Twin Lakes Golf and Country Club', 'Mature single-family stock', 'Lake access'],
    market: "Twin Lakes turns over slowly. Homes here stay in families. Sellers benefit from neighborhood reputation; buyers need patience.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  'alki-west-seattle': {
    slug: 'alki-homes',
    name: 'Alki',
    city: 'West Seattle',
    citySlug: 'west-seattle-real-estate-agent',
    county: 'King County',
    lat: 47.5760,
    lng: -122.4053,
    title: 'Alki Beach Homes for Sale | West Seattle | Mazen El-Majzoub',
    metaDescription: 'Alki Beach homes and condos for sale. West Seattle waterfront, beach views. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Alki, West Seattle',
    intro: "Alki is Seattle's beach — a two-mile waterfront strip facing downtown Seattle across Elliott Bay. Condos along the beach, craftsman blocks behind them, and views that define West Seattle identity.",
    highlights: ['Alki Beach Park waterfront', 'View condos along Alki Ave SW', 'Craftsman bungalows on inland blocks', 'Direct water taxi access to downtown'],
    market: "Alki waterfront condos trade at substantial premium. Inland craftsmans offer more accessible entry points. Lot-by-lot view variation matters.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },
  'the-junction-west-seattle': {
    slug: 'west-seattle-junction-homes',
    name: 'The Junction',
    city: 'West Seattle',
    citySlug: 'west-seattle-real-estate-agent',
    county: 'King County',
    lat: 47.5611,
    lng: -122.3866,
    title: 'West Seattle Junction Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'West Seattle Junction homes and condos. Walkable commercial core, farmers market. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'The Junction, West Seattle',
    intro: "The Junction anchors West Seattle's walkable commercial core — farmers market, restaurants, and new condo construction. Most-requested West Seattle address.",
    highlights: ['West Seattle Junction walkability', 'Sunday farmers market', 'Mix of condos, townhomes, single-family', 'Fastest-growing West Seattle submarket'],
    market: "The Junction sees both new condo inventory and craftsman resales. Condo pricing varies widely by building; single-family commands premium for walkability.",
    heroImage: 'https://images.unsplash.com/photo-1441906363429-0d71d3f97a62?w=1600&q=80',
  },
  'fauntleroy-west-seattle': {
    slug: 'fauntleroy-homes',
    name: 'Fauntleroy',
    city: 'West Seattle',
    citySlug: 'west-seattle-real-estate-agent',
    county: 'King County',
    lat: 47.5268,
    lng: -122.3967,
    title: 'Fauntleroy Homes for Sale | West Seattle | Mazen El-Majzoub',
    metaDescription: 'Fauntleroy West Seattle homes for sale. Ferry terminal, Lincoln Park, view homes. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Fauntleroy, West Seattle',
    intro: "Fauntleroy holds the Vashon Island ferry terminal and Lincoln Park — quiet, family-oriented, with view homes along the bluff. Slower pace than The Junction.",
    highlights: ['Fauntleroy ferry to Vashon and Southworth', 'Lincoln Park access', 'View homes along the bluff', 'Family-oriented streets'],
    market: "Fauntleroy view homes command substantial premiums. Non-view homes trade on school access and ferry-commuter appeal.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },
  'rainier-valley-seattle': {
    slug: 'rainier-valley-seattle-homes',
    name: 'Rainier Valley',
    city: 'Seattle',
    citySlug: 'seattle-real-estate-agent',
    county: 'King County',
    lat: 47.5532,
    lng: -122.2842,
    title: 'Rainier Valley Seattle Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Rainier Valley Seattle homes for sale. Diverse community, light rail, value vs Capitol Hill. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Rainier Valley, Seattle',
    intro: "Rainier Valley spans southeast Seattle along the Sound Transit light rail line — one of the city's most diverse areas with strong revitalization momentum.",
    highlights: ['Sound Transit light rail corridor', 'Diverse community feel', 'Value pricing vs north Seattle', 'Revitalizing commercial corridors'],
    market: "Rainier Valley pricing has climbed substantially but still offers value vs Capitol Hill or Ballard. Light rail and ongoing investment drive continued appreciation.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },
  'first-hill-seattle': {
    slug: 'first-hill-seattle-homes',
    name: 'First Hill',
    city: 'Seattle',
    citySlug: 'seattle-real-estate-agent',
    county: 'King County',
    lat: 47.6079,
    lng: -122.3258,
    title: 'First Hill Seattle Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'First Hill Seattle condos for sale. Medical district, downtown access, urban living. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'First Hill, Seattle',
    intro: "First Hill — 'Pill Hill' — anchors Seattle's medical district. Dense condo inventory, walking distance to downtown, and strong demand from medical professionals.",
    highlights: ['Virginia Mason, Swedish, Harborview hospitals', 'Walkable to downtown and Capitol Hill', 'Heavy condo and high-rise inventory', 'Streetcar access'],
    market: "First Hill trades almost entirely in condos. Pricing varies enormously by building — age, HOA, and amenities matter more than unit size.",
    heroImage: 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=1600&q=80',
  },
  'kennydale-renton': {
    slug: 'kennydale-renton-homes',
    name: 'Kennydale',
    city: 'Renton',
    citySlug: 'renton-real-estate-agent',
    county: 'King County',
    lat: 47.5062,
    lng: -122.1927,
    title: 'Kennydale Renton Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Kennydale Renton homes for sale. Lake Washington waterfront, view homes. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Kennydale, Renton',
    intro: "Kennydale lines Lake Washington's south shore — waterfront homes, view lots, and some of Renton's most premium addresses.",
    highlights: ['Lake Washington waterfront inventory', 'Renton School District', 'Gene Coulon Park access', 'Eastside employer proximity'],
    market: "Kennydale waterfront trades well into seven figures. Inland view homes command premium; non-view homes trade on block and school access.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },
  'renton-highlands': {
    slug: 'renton-highlands-homes',
    name: 'Renton Highlands',
    city: 'Renton',
    citySlug: 'renton-real-estate-agent',
    county: 'King County',
    lat: 47.5104,
    lng: -122.1798,
    title: 'Renton Highlands Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Renton Highlands homes for sale. Family community, Issaquah schools, newer construction. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Renton Highlands',
    intro: "Renton Highlands sits on the plateau above downtown Renton — family neighborhoods, newer construction, and Issaquah School District access on parts of the east side.",
    highlights: ['Issaquah and Renton School Districts', 'Newer residential development', 'Family-focused community', 'Commute to Bellevue and Seattle'],
    market: "Renton Highlands attracts families. School district matters — homes in Issaquah SD zone trade at premium to Renton SD zone.",
    heroImage: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=80',
  },
  'lea-hill-auburn': {
    slug: 'lea-hill-auburn-homes',
    name: 'Lea Hill',
    city: 'Auburn',
    citySlug: 'auburn-real-estate-agent',
    county: 'King County',
    lat: 47.3309,
    lng: -122.1900,
    title: 'Lea Hill Auburn Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Lea Hill Auburn homes for sale. Family community, GRC College, newer subdivisions. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Lea Hill, Auburn',
    intro: "Lea Hill perches above the Green River Valley — family-oriented subdivisions, Green River College, and one of Auburn's most desired addresses.",
    highlights: ['Auburn and Dieringer School Districts', 'Green River College proximity', 'Newer construction inventory', 'Family-oriented community'],
    market: "Lea Hill inventory is steady; family cycles drive turnover. I've closed homes here — the buyer pool is predictable.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },
  'lakeland-hills-auburn': {
    slug: 'lakeland-hills-auburn-homes',
    name: 'Lakeland Hills',
    city: 'Auburn',
    citySlug: 'auburn-real-estate-agent',
    county: 'King County',
    lat: 47.2823,
    lng: -122.2112,
    title: 'Lakeland Hills Auburn Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Lakeland Hills Auburn homes for sale. Master-planned community, newer construction, Dieringer schools. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Lakeland Hills, Auburn',
    intro: "Lakeland Hills is Auburn's master-planned community on the south plateau — consistent newer construction, family amenities, and Dieringer School District.",
    highlights: ['Dieringer School District', 'Master-planned community amenities', 'Newer construction consistency', 'Resale demand driven by schools'],
    market: "Lakeland Hills comps well — similar floor plans, predictable pricing. New-construction incentives vs resale values matter here.",
    heroImage: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1600&q=80',
  },
  'east-hill-kent': {
    slug: 'east-hill-kent-homes',
    name: 'East Hill',
    city: 'Kent',
    citySlug: 'kent-real-estate-agent',
    county: 'King County',
    lat: 47.3814,
    lng: -122.2009,
    title: 'East Hill Kent Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'East Hill Kent homes for sale. Most-demand Kent submarket, family community, value. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'East Hill, Kent',
    intro: "East Hill is the most-requested Kent submarket — family neighborhoods, strong schools, and pricing that beats Renton or Bellevue for comparable floor plans.",
    highlights: ['Kent School District', 'Family-oriented subdivisions', 'Lake Meridian recreation access', 'Commute to Bellevue and Renton'],
    market: "East Hill moves faster than other Kent submarkets. Well-priced family homes see multiple offers; sellers benefit from sharpest pricing.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },
  'lake-meridian-kent': {
    slug: 'lake-meridian-kent-homes',
    name: 'Lake Meridian',
    city: 'Kent',
    citySlug: 'kent-real-estate-agent',
    county: 'King County',
    lat: 47.3656,
    lng: -122.1498,
    title: 'Lake Meridian Kent Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Lake Meridian Kent waterfront homes for sale. Premium East Hill pocket. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Lake Meridian, Kent',
    intro: "Lake Meridian is Kent's waterfront premium pocket — lakefront homes, boating access, and the highest-priced Kent addresses.",
    highlights: ['Lake Meridian waterfront inventory', 'Kent School District', 'Boating and recreation access', 'Premium pricing vs Kent median'],
    market: "Lake Meridian waterfront trades well above Kent median. Tight inventory; buyers need to move quickly.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },
  'education-hill-redmond': {
    slug: 'education-hill-redmond-homes',
    name: 'Education Hill',
    city: 'Redmond',
    citySlug: 'redmond-real-estate-agent',
    county: 'King County',
    lat: 47.6871,
    lng: -122.1062,
    title: 'Education Hill Redmond Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Education Hill Redmond homes for sale. Family community, Lake Washington schools, top demand. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Education Hill, Redmond',
    intro: "Education Hill is Redmond's most-demanded family neighborhood — Lake Washington School District, walkable to Redmond High School, and steady Microsoft-driven demand.",
    highlights: ['Lake Washington School District', 'Redmond High School attendance area', 'Walking distance to Redmond town center', 'Strong Microsoft buyer pool'],
    market: "Education Hill inventory turns over with Microsoft relocation cycles. Homes here rarely sit when priced right.",
    heroImage: 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=1600&q=80',
  },
  'overlake-redmond': {
    slug: 'overlake-redmond-homes',
    name: 'Overlake',
    city: 'Redmond',
    citySlug: 'redmond-real-estate-agent',
    county: 'King County',
    lat: 47.6410,
    lng: -122.1392,
    title: 'Overlake Redmond Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Overlake Redmond homes and condos. Microsoft HQ, light rail, tech-corridor center. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Overlake, Redmond',
    intro: "Overlake anchors Microsoft's headquarters and the East Link light rail — dense condo and townhome development at the center of the Eastside tech corridor.",
    highlights: ['Microsoft main campus', 'East Link light rail station', 'Heavy condo and townhome inventory', 'Bellevue and Redmond School Districts'],
    market: "Overlake condo pricing tracks tech-employer demand. Newer high-rise towers command premiums; older stock offers entry points.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },
  'issaquah-highlands': {
    slug: 'issaquah-highlands-homes',
    name: 'Issaquah Highlands',
    city: 'Issaquah',
    citySlug: 'issaquah-real-estate-agent',
    county: 'King County',
    lat: 47.5579,
    lng: -122.0297,
    title: 'Issaquah Highlands Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Issaquah Highlands homes for sale. Master-planned community, top schools, tech demand. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Issaquah Highlands',
    intro: "Issaquah Highlands is the master-planned community on the plateau above downtown Issaquah — walkable village, top schools, and strong Microsoft/Costco employer demand.",
    highlights: ['Issaquah School District — top statewide', 'Walkable village center', 'Park-and-ride to Seattle/Bellevue', 'Master-planned consistency'],
    market: "Issaquah Highlands comps are predictable but pricing is firm. Tech-employer demand keeps inventory tight.",
    heroImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80',
  },
  'klahanie-issaquah': {
    slug: 'klahanie-homes',
    name: 'Klahanie',
    city: 'Issaquah',
    citySlug: 'issaquah-real-estate-agent',
    county: 'King County',
    lat: 47.5718,
    lng: -122.0574,
    title: 'Klahanie Homes for Sale | Issaquah | Mazen El-Majzoub',
    metaDescription: 'Klahanie Issaquah homes for sale. Family community, top schools, trail access. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Klahanie, Issaquah',
    intro: "Klahanie is an established Issaquah master-planned community — family-oriented trails, Issaquah School District, and steady long-term resident retention.",
    highlights: ['Issaquah School District', 'Extensive Klahanie trail system', 'Family-oriented community', 'Multiple neighborhood parks'],
    market: "Klahanie trades on school district strength and community amenities. Families stay long-term; inventory is tight.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },
  'juanita-kirkland': {
    slug: 'juanita-kirkland-homes',
    name: 'Juanita',
    city: 'Kirkland',
    citySlug: 'kirkland-real-estate-agent',
    county: 'King County',
    lat: 47.7034,
    lng: -122.2048,
    title: 'Juanita Kirkland Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Juanita Kirkland homes for sale. Lake Washington waterfront, Juanita Beach, family community. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Juanita, Kirkland',
    intro: "Juanita sits at the north end of Lake Washington — Juanita Beach Park, waterfront homes, and family-oriented streets inland.",
    highlights: ['Juanita Beach Park waterfront', 'Lake Washington School District', 'Mix of waterfront, view, and family homes', 'Walking distance to Juanita Village'],
    market: "Juanita waterfront is premium; inland blocks offer more accessible Kirkland entry points.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },
  'rose-hill-kirkland': {
    slug: 'rose-hill-kirkland-homes',
    name: 'Rose Hill',
    city: 'Kirkland',
    citySlug: 'kirkland-real-estate-agent',
    county: 'King County',
    lat: 47.6732,
    lng: -122.1654,
    title: 'Rose Hill Kirkland Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Rose Hill Kirkland homes for sale. Family community, Lake Washington Schools, value. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Rose Hill, Kirkland',
    intro: "Rose Hill is Kirkland's family-oriented inland neighborhood — mid-century single-family, Lake Washington School District, and more accessible pricing than downtown Kirkland.",
    highlights: ['Lake Washington School District', 'Mid-century single-family stock', 'Microsoft commuter access', 'Value vs waterfront Kirkland'],
    market: "Rose Hill trades below Juanita or downtown Kirkland waterfront. Family-driven demand is steady.",
    heroImage: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=80',
  },
  'tehaleh-bonney-lake': {
    slug: 'tehaleh-homes',
    name: 'Tehaleh',
    city: 'Bonney Lake',
    citySlug: 'bonney-lake-real-estate-agent',
    county: 'Pierce County',
    lat: 47.1444,
    lng: -122.1425,
    title: 'Tehaleh Homes for Sale | Bonney Lake | Mazen El-Majzoub',
    metaDescription: 'Tehaleh homes for sale. Master-planned community, mountain views, newer construction. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Tehaleh, Bonney Lake',
    intro: "Tehaleh is Pierce County's newest master-planned community — Mount Rainier views, consistent architecture, and strong family-oriented community planning.",
    highlights: ['Sumner-Bonney Lake School District', 'Mount Rainier view lots', 'Newer construction across multiple builders', 'Community amenities — pool, trails, parks'],
    market: "Tehaleh is still actively building out. New-construction pricing vs resale of similar floor plans matters — I help clients weigh both.",
    heroImage: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=1600&q=80',
  },
  'lake-tapps': {
    slug: 'lake-tapps-homes',
    name: 'Lake Tapps',
    city: 'Bonney Lake',
    citySlug: 'bonney-lake-real-estate-agent',
    county: 'Pierce County',
    lat: 47.2128,
    lng: -122.1682,
    title: 'Lake Tapps Waterfront Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Lake Tapps waterfront homes for sale. Bonney Lake premium pocket. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Lake Tapps',
    intro: "Lake Tapps is Pierce County's signature waterfront lake — premium homes, boating, and one of the most desired addresses in east Pierce.",
    highlights: ['Lake Tapps waterfront inventory', 'Sumner-Bonney Lake School District', 'Boating and recreation access', 'Premium pricing within Pierce County'],
    market: "Lake Tapps waterfront trades at substantial premium to surrounding inland homes. Inventory is tight; buyers need readiness.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },
  'winslow-bainbridge': {
    slug: 'winslow-bainbridge-homes',
    name: 'Winslow',
    city: 'Bainbridge Island',
    citySlug: 'bainbridge-island-real-estate-agent',
    county: 'Kitsap County',
    lat: 47.6231,
    lng: -122.5206,
    title: 'Winslow Bainbridge Island Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Winslow Bainbridge Island homes and condos. Walkable village, Seattle ferry. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Winslow, Bainbridge Island',
    intro: "Winslow is Bainbridge's walkable village — ferry terminal, shops, restaurants, and a mix of condos, townhomes, and single-family within walking distance of the Seattle ferry.",
    highlights: ['Bainbridge-Seattle ferry terminal', 'Walkable village core', 'Mix of condos, townhomes, single-family', 'Bainbridge Island School District'],
    market: "Winslow's walkability commands premium. Ferry-commuter buyers pay up for the ability to walk to the terminal.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },
  'manchester-kitsap': {
    slug: 'manchester-kitsap-homes',
    name: 'Manchester',
    city: 'Port Orchard',
    citySlug: 'port-orchard-real-estate-agent',
    county: 'Kitsap County',
    lat: 47.5537,
    lng: -122.5404,
    title: 'Manchester Kitsap Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Manchester WA homes for sale. Waterfront community, Port Orchard, Navy-adjacent. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Manchester, Kitsap',
    intro: "Manchester is a small waterfront Kitsap community across Rich Passage from Seattle — quiet, affordable, and Navy-adjacent.",
    highlights: ['South Kitsap School District', 'Rich Passage waterfront', 'Navy base proximity', 'Value vs Bainbridge'],
    market: "Manchester waterfront offers strong value. Limited inventory; buyers patient enough to wait get rewarded.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },
  'suquamish-kitsap': {
    slug: 'suquamish-kitsap-homes',
    name: 'Suquamish',
    city: 'Poulsbo',
    citySlug: 'poulsbo-real-estate-agent',
    county: 'Kitsap County',
    lat: 47.7303,
    lng: -122.5565,
    title: 'Suquamish Kitsap Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Suquamish Kitsap homes for sale. Waterfront community, tribal history, Poulsbo adjacent. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Suquamish, Kitsap',
    intro: "Suquamish sits on the north Kitsap waterfront — historic tribal lands, Agate Pass views, and strong value relative to Bainbridge or Poulsbo.",
    highlights: ['North Kitsap School District', 'Agate Pass waterfront', 'Suquamish Tribe cultural history', 'Value alternative to Bainbridge'],
    market: "Suquamish offers waterfront pricing well below Bainbridge. Tribal land and fee-simple distinctions matter — due diligence critical.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },
  'hawks-prairie-lacey': {
    slug: 'hawks-prairie-lacey-homes',
    name: 'Hawks Prairie',
    city: 'Lacey',
    citySlug: 'lacey-real-estate-agent',
    county: 'Thurston County',
    lat: 47.0570,
    lng: -122.7834,
    title: 'Hawks Prairie Lacey Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Hawks Prairie Lacey homes for sale. Newer construction, family community, North Thurston schools. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Hawks Prairie, Lacey',
    intro: "Hawks Prairie is Lacey's fastest-growing area — newer master-planned communities, family amenities, and North Thurston School District access.",
    highlights: ['North Thurston School District', 'Newer master-planned communities', 'Commercial and retail expansion', 'Family-oriented planning'],
    market: "Hawks Prairie pricing tracks new construction closely. Builder incentives vs resale comps matter here.",
    heroImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80',
  },
  'snoqualmie-ridge': {
    slug: 'snoqualmie-ridge-homes',
    name: 'Snoqualmie Ridge',
    city: 'Snoqualmie',
    citySlug: 'snoqualmie-real-estate-agent',
    county: 'King County',
    lat: 47.5405,
    lng: -121.8398,
    title: 'Snoqualmie Ridge Homes for Sale | Mazen El-Majzoub',
    metaDescription: 'Snoqualmie Ridge homes for sale. Master-planned community, top schools, mountain views. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Snoqualmie Ridge',
    intro: "Snoqualmie Ridge is one of the Pacific Northwest's most successful master-planned communities — walkable village, top schools, and consistent architecture across neighborhoods.",
    highlights: ['Snoqualmie Valley School District', 'Master-planned walkability', 'Cascade foothills views', 'Family-oriented community planning'],
    market: "Snoqualmie Ridge inventory trades with predictable comps. Tech-employer demand keeps pricing firm.",
    heroImage: 'https://images.unsplash.com/photo-1685841295958-2695cbed9093?w=1600&q=80',
  },
  'somerset-bellevue': {
    slug: 'somerset-bellevue-homes',
    name: 'Somerset',
    city: 'Bellevue',
    citySlug: 'bellevue-real-estate-agent',
    county: 'King County',
    lat: 47.5659,
    lng: -122.1651,
    title: 'Somerset Bellevue Homes for Sale | Mazen El-Majzoub',
    metaDescription:
      'Homes for sale in Somerset, Bellevue. View lots, top schools, executive pricing. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Somerset, Bellevue',
    intro:
      "Somerset sits on the south side of Bellevue's signature hillside, offering some of the best view real estate on the Eastside — Lake Washington, Seattle skyline, and Olympic Mountains from the upper tiers. The neighborhood draws tech executives and established professionals who can afford the top of the Bellevue market.",
    highlights: [
      'Panoramic views from upper-tier homes',
      'Bellevue School District — Somerset Elementary, Tyee Middle, Newport High',
      'Executive-tier pricing with strong resale',
      'Quick access to I-405 and I-90',
    ],
    market:
      "Somerset is one of the highest-priced residential neighborhoods in Washington — upper-tier view homes regularly close above $3M, and even non-view homes command premium pricing for the school district alone. Transactions here reward detailed pricing analysis and precise negotiation.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },
};
